<template>
    <!-- eslint-disable-next-line -->
    <div id="info" v-html="safeInfo">
    </div>
</template>

<script>
import P from 'bluebird';

export default {
    name: 'InfoView',
    props: {
        info: undefined,
    },
    data: () => ({
        rawInfo: undefined,
    }),
    computed: {
        safeInfo: function () {
            if (!this.rawInfo) return;
            //no img or script tags allowed
            const info = this.rawInfo.replace(
                /<\s*img(.*?)<\/\s*img\s*>/gm,
                '',
            );
            return info.replace(/<\s*script(.*?)<\/\s*script\s*>/gm, '');
        },
    },
    watch: {
        info: async function () {
            this.rawInfo = await P.resolve(this.info).catch(
                () => 'Could Not Load Page',
            );
        },
    },
    async created() {
        this.rawInfo = await this.info;
    },
};
</script>
<style lang="scss">
#info {
    width: 90%;
    margin: 2rem auto;
    background-color: #fff;
    color: #333;
    padding: 5%;
    border-radius: 0.25rem;
    text-align: left;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.9rem;
    line-height: 1.5em;

    @media (min-width: 600px) {
        width: 80%;
        margin: 4rem auto;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        text-align: center;
        font-family: inherit;
        line-height: 1.1;
        font-weight: 500;
        margin-top: 0.67rem;
        margin-bottom: 0.67rem;
        @media (min-width: 1280px) {
            text-align: inherit;
        }
    }
    h1,
    h2,
    h3 {
        margin-top: 1.34rem;
    }
    h1 {
        font-size: 2.4rem;
    }
    h2 {
        font-size: 2rem;
    }
    h3 {
        font-size: 1.6rem;
    }
    h4 {
        font-size: 1.2rem;
    }
    h5 {
        font-size: 0.934rem;
    }
    h6 {
        font-size: 0.9rem;
    }
    a {
        text-decoration: underline;
    }
}
</style>
